import React, { Component } from "react";
import Topnav from "../common/Topnav";
import Footer from "../common/Footer";
import { Container, Row, Col, Breadcrumb } from "react-bootstrap";
import bannerImage from "../../Images/about/about_banner.webp";
import extraCurriculum from "../../Images/campus/extracurriculum-cultural.webp"

import icon1 from "../../Images/campus/campusIcon1.webp";
import icon2 from "../../Images/campus/campusIcon2.webp";
import icon3 from "../../Images/campus/campusIcon3.webp";
import icon4 from "../../Images/campus/campusIcon4.webp";
import icon5 from "../../Images/campus/campusIcon5.webp";
import icon6 from "../../Images/campus/campusIcon6.webp";
import icon7 from "../../Images/campus/campusIcon7.webp";
import icon8 from "../../Images/campus/campusIcon8.webp";
import icon9 from "../../Images/campus/campusIcon9.webp";
import icon10 from "../../Images/campus/campusIcon10.webp";
import icon11 from "../../Images/campus/campusIcon11.webp";
import icon12 from "../../Images/campus/campusIcon12.webp";
import icon13 from "../../Images/campus/campusIcon13.webp";
import icon14 from "../../Images/campus/campusIcon14.webp";
import icon15 from "../../Images/campus/campusIcon15.webp";
import icon16 from "../../Images/campus/campusIcon16.webp";

import pic1 from "../../Images/campus/campus-1.webp";
import pic2 from "../../Images/campus/campus-2.webp";
import pic3 from "../../Images/campus/campus-3.webp";
import pic4 from "../../Images/campus/campus-4.webp";
import pic5 from "../../Images/campus/campus-5.webp";
import pic6 from "../../Images/campus/campus-6.webp";
import pic7 from "../../Images/campus/campus-7.webp";
import pic8 from "../../Images/campus/campus-8.webp";
import pic9 from "../../Images/campus/campus-9.webp";
import pic10 from "../../Images/campus/campus-10.webp";
import pic11 from "../../Images/campus/campus-11.webp";
import pic12 from "../../Images/campus/campus-12.webp";
import pic13 from "../../Images/campus/campus-13.webp";
import pic14 from "../../Images/campus/campus-14.webp";
import pic15 from "../../Images/campus/campus-15.webp";
import pic16 from "../../Images/campus/campus-16.webp";
import pic17 from "../../Images/campus/campus-17.webp";
import pic18 from "../../Images/campus/campus-18.webp";

import acdpic1 from "../../Images/campus/lib-1.webp";
import acdpic2 from "../../Images/campus/library-1.webp";
import acdpic3 from "../../Images/campus/campus-15.webp";
import acdpic4 from "../../Images/campus/reading-room-2.webp";

import labpic1 from "../../Images/campus/lab-1.webp";
import labpic2 from "../../Images/campus/lab-2.webp";
import labpic3 from "../../Images/campus/lab-3.webp";
import labpic4 from "../../Images/campus/lab-4.webp";
import labpic5 from "../../Images/campus/lab-5.webp";
import labpic6 from "../../Images/campus/lab-6.webp";
import labpic7 from "../../Images/campus/lab-7.webp";
import labpic8 from "../../Images/campus/lab-8.webp";
import labpic9 from "../../Images/campus/lab-9.webp";
import labpic10 from "../../Images/campus/lab-10.webp";
import labpic11 from "../../Images/campus/lab-11.webp";
import labpic12 from "../../Images/campus/lab-12.webp";

import sportspic1 from "../../Images/sports/sports-1.webp";
import sportspic2 from "../../Images/sports/sports-2.webp";
import sportspic3 from "../../Images/sports/sports-3.webp";
import sportspic4 from "../../Images/sports/sports-4.webp";
import sportspic5 from "../../Images/sports/sports-5.webp";
import sportspic6 from "../../Images/sports/sports-6.webp";
import sportspic7 from "../../Images/sports/sports-7.webp";
import sportspic8 from "../../Images/sports/sports-8.webp";
import sportspic9 from "../../Images/sports/sports-9.webp";
import sportspic10 from "../../Images/sports/sports-10.webp";
import sportspic11 from "../../Images/sports/sports-11.webp";
import sportspic12 from "../../Images/sports/sports-12.webp";

import hostelpic1 from "../../Images/campus/hostel-1.webp";
import hostelpic2 from "../../Images/campus/hostel-2.webp";
import hostelpic3 from "../../Images/campus/hostel-3.webp";
import hostelpic4 from "../../Images/campus/hostel-4.webp";
import hostelpic5 from "../../Images/campus/hostel-5.webp";
import hostelpic6 from "../../Images/campus/canteen-1.webp";
import hostelpic7 from "../../Images/campus/hostel-6.webp";
import hostelpic8 from "../../Images/campus/reading-room-1.webp";

import workshopspic1 from "../../Images/campus/workshop-1.webp";
import workshopspic2 from "../../Images/campus/workshop-2.webp";
import workshopspic3 from "../../Images/campus/workshop-3.webp";
import workshopspic4 from "../../Images/campus/workshop-4.webp";
import workshopspic5 from "../../Images/campus/workshop-5.webp";
import workshopspic6 from "../../Images/campus/workshop-6.webp";
import workshopspic7 from "../../Images/campus/workshop-7.webp";
import workshopspic8 from "../../Images/campus/workshop-8.webp";


const CampusInfrastructure = () => {
    return (
        <>
            <title>ISBM University Campus Infrastructure | Modern Facilities </title>
            <meta
                name="description"
                content="Explore ISBM University's modern campus with smart classrooms, labs, and hostels. Experience top facilities for learning and growth. Visit us today."
            />
            <Topnav />
            <section
                className="section-hero-banner ptb-50"
                style={{
                    backgroundImage: `linear-gradient(rgba(28,36,71,0.8), rgba(28,36,71,0.8)), url(${bannerImage})`,
                }}
            >
                <div className="banner-hero-overlay">
                    <div className="container-xxl">
                        <div className="section-hero-content">
                            <h1>Campus Infrastructure</h1>
                            <ol className="breadcrumb mt-3 text-center mb-0">
                                <li className="breadcrumb-item">
                                    <a href="/" style={{ color: "#fff", textDecoration: "none" }}>
                                        Home
                                    </a>
                                </li>
                                <li
                                    className="breadcrumb-item active text-white"
                                    aria-current="page"
                                >
                                    Campus Infrastructure
                                </li>
                                <hr className="section-divider" />
                            </ol>
                        </div>
                    </div>
                </div>
            </section>

            <section className="ptb-50">
                <div className="container-xxl">
                    <div class="text-center mb-5">
                        <h2 class="section-title modern-title text-blue mt-3">Campus Overview</h2>
                        <p class="section-subtitle mx-auto fw-semibold">
                            Explore, Engage, and Embrace the Vibrant Spirit of Campus Life
                        </p>
                    </div>
                    <div className="vc-paragraphs mx-auto">
                        <p>
                            ISBM University boasts a modern and vibrant campus that is designed to facilitate an engaging learning environment. Situated in a spacious setting, the campus features state-of- the-art facilities, including well-equipped classrooms, advanced laboratories, and dedicated study areas. The University also provides ample resources for research and innovation, including libraries stocked with a wide range of academic materials.
                        </p>
                        <p>
                            The sprawling 26 acre campus of ISBM University is nestled in the heart of nature. The sylvan surroundings of the campus amidst the forest and hills, provide an inspiring learning environment for everyone. Blessed with the divinity of Tenganhi Mata (Durga Maa) Temple in its neighbourhood, the campus is complete with all modern facility and features.
                        </p>
                        <p>
                            In addition to academic facilities, the campus offers recreational areas, sports facilities, and spaces for extracurricular activities, promoting a well-rounded student experience. Students can participate in various clubs and organizations that foster community and collaboration. The University's commitment to a supportive and inclusive environment is reflected in its infrastructure, which is designed to accommodate diverse needs. Overall, ISBM University’s campus serves as a hub for academic excellence, personal growth, and social interaction, making it an ideal place for students to thrive.
                        </p>
                    </div>
                </div>
            </section>

            {/* Vibrant Campus  */}
            <section className="ptb-50 bg-blue">
                <div className="container-xxl">
                    <h2 className="section-title-start modern-title mb-0">
                        A Glimpse into Our
                        <span className="main-header-content text-golden"> Vibrant Campus </span>Where
                        Learning Meets Lifestyle
                    </h2>
                    <h6 class="modern-subtitle text-golden">
                        At ISBM University, we are committed to developing leaders who are
                        not merely skilled professionals but also compassionate people with
                        strong ethical values.
                    </h6>
                    <p>
                        ISBM University is committed to encourage many ideas from diverse
                        sources, creating a flower bed of entrepreneurship and start-ups. It
                        also reflects the vision of ISBM University that wants to see
                        thousands of youth opening their minds to new vistas and
                        opportunities by using the power of knowledge, skills and incubation
                        provided by ISBM&nbsp;University.
                    </p>

                    <nav>
                        <div class="nav nav-underline" id="nav-tab" role="tablist">
                            <button
                                class="nav-link active"
                                id="nav-campus-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#nav-campus"
                                type="button"
                                role="tab"
                                aria-controls="nav-campus"
                                aria-selected="true"
                            >
                                Campus
                            </button>
                            <button
                                class="nav-link"
                                id="nav-academics-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#nav-academics"
                                type="button"
                                role="tab"
                                aria-controls="nav-academics"
                                aria-selected="false"
                            >
                                Academics
                            </button>
                            <button
                                class="nav-link"
                                id="nav-lab-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#nav-lab"
                                type="button"
                                role="tab"
                                aria-controls="nav-lab"
                                aria-selected="false"
                            >
                                Laboratories
                            </button>
                            <button
                                class="nav-link"
                                id="nav-sports-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#nav-sports"
                                type="button"
                                role="tab"
                                aria-controls="nav-sports"
                                aria-selected="false"
                            >
                                Sports
                            </button>
                            <button
                                class="nav-link"
                                id="nav-hostel-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#nav-hostel"
                                type="button"
                                role="tab"
                                aria-controls="nav-hostel"
                                aria-selected="false"
                            >
                                Hostel
                            </button>
                            <button
                                class="nav-link"
                                id="nav-workshops-tab"
                                data-bs-toggle="tab"
                                data-bs-target="#nav-workshops"
                                type="button"
                                role="tab"
                                aria-controls="nav-workshops"
                                aria-selected="false"
                            >
                                Workshops
                            </button>
                        </div>
                    </nav>
                    <div class="tab-content" id="nav-tabContent">
                        <div
                            class="tab-pane fade show active"
                            id="nav-campus"
                            role="tabpanel"
                            aria-labelledby="nav-campus-tab"
                            tabindex="0"
                        >
                            <Row className="gallery-row align-items-stretch mt-lg-5 mx-0">
                                {/* Left side - 4 images in 2x2 grid */}
                                <Col lg={6} className="gallery-col p-0">
                                    <Row className="gallery-inner-row g-3">
                                        <Col xs={6} className="gallery-inner-col">
                                            <div className="collage-item small-item">
                                                <div className="gallery-image-wrapper">
                                                    <img src={pic1} className="gallery-image" />
                                                    <div className="image-overlay">
                                                        <div className="overlay-content"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xs={6} className="gallery-inner-col">
                                            <div className="collage-item small-item">
                                                <div className="gallery-image-wrapper">
                                                    <img src={pic6} className="gallery-image" />
                                                    <div className="image-overlay">
                                                        <div className="overlay-content"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xs={12} className="gallery-inner-col">
                                            <div className="collage-item small-item">
                                                <div className="gallery-image-wrapper">
                                                    <img src={pic3} className="gallery-image" />
                                                    <div className="image-overlay">
                                                        <div className="overlay-content">
                                                            <p></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>

                                {/* Right side - 1 big image */}
                                <Col lg={6} className="gallery-col">
                                    <div className="collage-item large-item">
                                        <div className="gallery-image-wrapper">
                                            <img src={pic5} className="gallery-image" />
                                            <div className="image-overlay">
                                                <div className="overlay-content">
                                                    <h3></h3>
                                                    <p></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row className="gallery-row align-items-stretch mt-4 mx-0">
                                {/* Left side - 4 images in 2x2 grid */}
                                <Col lg={6} className="gallery-col">
                                    <div className="collage-item large-item">
                                        <div className="gallery-image-wrapper">
                                            <img src={pic2} className="gallery-image" />
                                            <div className="image-overlay">
                                                <div className="overlay-content">
                                                    <h3></h3>
                                                    <p></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>

                                {/* Right side - 1 big image */}
                                <Col lg={6} className="gallery-col p-0">
                                    <Row className="gallery-inner-row g-3">
                                        <Col xs={6} className="gallery-inner-col">
                                            <div className="collage-item small-item">
                                                <div className="gallery-image-wrapper">
                                                    <img src={pic4} className="gallery-image" />
                                                    <div className="image-overlay">
                                                        <div className="overlay-content"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xs={6} className="gallery-inner-col">
                                            <div className="collage-item small-item">
                                                <div className="gallery-image-wrapper">
                                                    <img src={pic7} className="gallery-image" />
                                                    <div className="image-overlay">
                                                        <div className="overlay-content"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xs={12} className="gallery-inner-col">
                                            <div className="collage-item small-item">
                                                <div className="gallery-image-wrapper">
                                                    <img src={pic9} className="gallery-image" />
                                                    <div className="image-overlay">
                                                        <div className="overlay-content">
                                                            <p></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row className="gallery-row align-items-stretch mt-4 mx-0">
                                {/* Left side - 4 images in 2x2 grid */}
                                <Col lg={6} className="gallery-col p-0">
                                    <Row className="gallery-inner-row g-3">
                                        <Col xs={6} className="gallery-inner-col">
                                            <div className="collage-item small-item">
                                                <div className="gallery-image-wrapper">
                                                    <img src={pic10} className="gallery-image" />
                                                    <div className="image-overlay">
                                                        <div className="overlay-content"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xs={6} className="gallery-inner-col">
                                            <div className="collage-item small-item">
                                                <div className="gallery-image-wrapper">
                                                    <img src={pic11} className="gallery-image" />
                                                    <div className="image-overlay">
                                                        <div className="overlay-content"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xs={12} className="gallery-inner-col">
                                            <div className="collage-item small-item">
                                                <div className="gallery-image-wrapper">
                                                    <img src={pic12} className="gallery-image" />
                                                    <div className="image-overlay">
                                                        <div className="overlay-content">
                                                            <p></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>

                                {/* Right side - 1 big image */}
                                <Col lg={6} className="gallery-col">
                                    <div className="collage-item large-item">
                                        <div className="gallery-image-wrapper">
                                            <img src={pic14} className="gallery-image" />
                                            <div className="image-overlay">
                                                <div className="overlay-content"></div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row className="gallery-row align-items-stretch mt-4 mx-0">
                                {/* Left side - 4 images in 2x2 grid */}
                                <Col lg={6} className="gallery-col">
                                    <div className="collage-item large-item">
                                        <div className="gallery-image-wrapper">
                                            <img src={pic15} className="gallery-image" />
                                            <div className="image-overlay">
                                                <div className="overlay-content">
                                                    <h3></h3>
                                                    <p></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>

                                {/* Right side - 1 big image */}
                                <Col lg={6} className="gallery-col p-0">
                                    <Row className="gallery-inner-row g-3">
                                        <Col xs={6} className="gallery-inner-col">
                                            <div className="collage-item small-item">
                                                <div className="gallery-image-wrapper">
                                                    <img src={pic16} className="gallery-image" />
                                                    <div className="image-overlay">
                                                        <div className="overlay-content"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xs={6} className="gallery-inner-col">
                                            <div className="collage-item small-item">
                                                <div className="gallery-image-wrapper">
                                                    <img src={pic17} className="gallery-image" />
                                                    <div className="image-overlay">
                                                        <div className="overlay-content"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xs={12} className="gallery-inner-col">
                                            <div className="collage-item small-item">
                                                <div className="gallery-image-wrapper">
                                                    <img src={pic18} className="gallery-image" />
                                                    <div className="image-overlay">
                                                        <div className="overlay-content">
                                                            <p></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                        <div
                            class="tab-pane fade"
                            id="nav-academics"
                            role="tabpanel"
                            aria-labelledby="nav-academics-tab"
                            tabindex="0"
                        >
                            <Row className="gallery-row align-items-stretch mt-lg-5 mx-0">
                                {/* Left side - 4 images in 2x2 grid */}
                                <Col lg={6} className="gallery-col p-0">
                                    <Row className="gallery-inner-row g-3">
                                        <Col xs={6} className="gallery-inner-col">
                                            <div className="collage-item small-item">
                                                <div className="gallery-image-wrapper">
                                                    <img src={acdpic1} className="gallery-image" />
                                                    <div className="image-overlay">
                                                        <div className="overlay-content">
                                                            <p></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xs={6} className="gallery-inner-col">
                                            <div className="collage-item small-item">
                                                <div className="gallery-image-wrapper">
                                                    <img
                                                        src={acdpic2}
                                                        alt="Kabaddi Team"
                                                        className="gallery-image"
                                                    />
                                                    <div className="image-overlay">
                                                        <div className="overlay-content"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xs={12} className="gallery-inner-col">
                                            <div className="collage-item small-item">
                                                <div className="gallery-image-wrapper">
                                                    <img src={acdpic3} className="gallery-image" />
                                                    <div className="image-overlay">
                                                        <div className="overlay-content">
                                                            <p></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>

                                {/* Right side - 1 big image */}
                                <Col lg={6} className="gallery-col">
                                    <div className="collage-item large-item">
                                        <div className="gallery-image-wrapper">
                                            <img src={acdpic4} className="gallery-image" />
                                            <div className="image-overlay">
                                                <div className="overlay-content">
                                                    <h3></h3>
                                                    <p></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                        <div
                            class="tab-pane fade"
                            id="nav-lab"
                            role="tabpanel"
                            aria-labelledby="nav-lab-tab"
                            tabindex="0"
                        >
                            <Row className="gallery-row align-items-stretch mt-lg-5 mx-0">
                                {/* Left side - 4 images in 2x2 grid */}
                                <Col lg={6} className="gallery-col p-0">
                                    <Row className="gallery-inner-row g-3">
                                        <Col xs={6} className="gallery-inner-col">
                                            <div className="collage-item small-item">
                                                <div className="gallery-image-wrapper">
                                                    <img src={labpic1} className="gallery-image" />
                                                    <div className="image-overlay">
                                                        <div className="overlay-content">
                                                            <p></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xs={6} className="gallery-inner-col">
                                            <div className="collage-item small-item">
                                                <div className="gallery-image-wrapper">
                                                    <img
                                                        src={labpic2}
                                                        alt="Kabaddi Team"
                                                        className="gallery-image"
                                                    />
                                                    <div className="image-overlay">
                                                        <div className="overlay-content"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xs={12} className="gallery-inner-col">
                                            <div className="collage-item small-item">
                                                <div className="gallery-image-wrapper">
                                                    <img src={labpic3} className="gallery-image" />
                                                    <div className="image-overlay">
                                                        <div className="overlay-content">
                                                            <p></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>

                                {/* Right side - 1 big image */}
                                <Col lg={6} className="gallery-col">
                                    <div className="collage-item large-item">
                                        <div className="gallery-image-wrapper">
                                            <img src={labpic4} className="gallery-image" />
                                            <div className="image-overlay">
                                                <div className="overlay-content">
                                                    <h3></h3>
                                                    <p></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row className="gallery-row align-items-stretch mt-lg-4 mx-0">
                                {/* Left side - 4 images in 2x2 grid */}
                                <Col lg={6} className="gallery-col">
                                    <div className="collage-item large-item">
                                        <div className="gallery-image-wrapper">
                                            <img src={labpic8} className="gallery-image" />
                                            <div className="image-overlay">
                                                <div className="overlay-content">
                                                    <h3></h3>
                                                    <p></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>

                                {/* Right side - 1 big image */}
                                <Col lg={6} className="gallery-col p-0">
                                    <Row className="gallery-inner-row g-3">
                                        <Col xs={6} className="gallery-inner-col">
                                            <div className="collage-item small-item">
                                                <div className="gallery-image-wrapper">
                                                    <img src={labpic5} className="gallery-image" />
                                                    <div className="image-overlay">
                                                        <div className="overlay-content">
                                                            <p></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xs={6} className="gallery-inner-col">
                                            <div className="collage-item small-item">
                                                <div className="gallery-image-wrapper">
                                                    <img
                                                        src={labpic6}
                                                        alt="Kabaddi Team"
                                                        className="gallery-image"
                                                    />
                                                    <div className="image-overlay">
                                                        <div className="overlay-content"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xs={12} className="gallery-inner-col">
                                            <div className="collage-item small-item">
                                                <div className="gallery-image-wrapper">
                                                    <img src={labpic7} className="gallery-image" />
                                                    <div className="image-overlay">
                                                        <div className="overlay-content">
                                                            <p></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row className="gallery-row align-items-stretch mt-lg-4 mx-0">
                                {/* Left side - 4 images in 2x2 grid */}
                                <Col lg={6} className="gallery-col p-0">
                                    <Row className="gallery-inner-row g-3">
                                        <Col xs={6} className="gallery-inner-col">
                                            <div className="collage-item small-item">
                                                <div className="gallery-image-wrapper">
                                                    <img src={labpic9} className="gallery-image" />
                                                    <div className="image-overlay">
                                                        <div className="overlay-content">
                                                            <p></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xs={6} className="gallery-inner-col">
                                            <div className="collage-item small-item">
                                                <div className="gallery-image-wrapper">
                                                    <img
                                                        src={labpic10}
                                                        alt="Kabaddi Team"
                                                        className="gallery-image"
                                                    />
                                                    <div className="image-overlay">
                                                        <div className="overlay-content"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xs={12} className="gallery-inner-col">
                                            <div className="collage-item small-item">
                                                <div className="gallery-image-wrapper">
                                                    <img src={labpic11} className="gallery-image" />
                                                    <div className="image-overlay">
                                                        <div className="overlay-content">
                                                            <p></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>

                                {/* Right side - 1 big image */}
                                <Col lg={6} className="gallery-col">
                                    <div className="collage-item large-item">
                                        <div className="gallery-image-wrapper">
                                            <img src={labpic12} className="gallery-image" />
                                            <div className="image-overlay">
                                                <div className="overlay-content">
                                                    <h3></h3>
                                                    <p></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                        <div
                            class="tab-pane fade"
                            id="nav-sports"
                            role="tabpanel"
                            aria-labelledby="nav-sports-tab"
                            tabindex="0"
                        >
                            <Row className="gallery-row align-items-stretch mt-lg-5 mx-0">
                                {/* Left side - 4 images in 2x2 grid */}
                                <Col lg={6} className="gallery-col p-0">
                                    <Row className="gallery-inner-row g-3">
                                        <Col xs={6} className="gallery-inner-col">
                                            <div className="collage-item small-item">
                                                <div className="gallery-image-wrapper">
                                                    <img src={sportspic1} className="gallery-image" />
                                                    <div className="image-overlay">
                                                        <div className="overlay-content">
                                                            <p></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xs={6} className="gallery-inner-col">
                                            <div className="collage-item small-item">
                                                <div className="gallery-image-wrapper">
                                                    <img
                                                        src={sportspic2}
                                                        alt="Kabaddi Team"
                                                        className="gallery-image"
                                                    />
                                                    <div className="image-overlay">
                                                        <div className="overlay-content"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xs={12} className="gallery-inner-col">
                                            <div className="collage-item small-item">
                                                <div className="gallery-image-wrapper">
                                                    <img src={sportspic3} className="gallery-image" />
                                                    <div className="image-overlay">
                                                        <div className="overlay-content">
                                                            <p></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>

                                {/* Right side - 1 big image */}
                                <Col lg={6} className="gallery-col">
                                    <div className="collage-item large-item">
                                        <div className="gallery-image-wrapper">
                                            <img src={sportspic4} className="gallery-image" />
                                            <div className="image-overlay">
                                                <div className="overlay-content">
                                                    <h3></h3>
                                                    <p></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row className="gallery-row align-items-stretch mt-lg-4 mx-0">
                                {/* Left side - 4 images in 2x2 grid */}
                                <Col lg={6} className="gallery-col">
                                    <div className="collage-item large-item">
                                        <div className="gallery-image-wrapper">
                                            <img src={sportspic8} className="gallery-image" />
                                            <div className="image-overlay">
                                                <div className="overlay-content">
                                                    <h3></h3>
                                                    <p></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>

                                {/* Right side - 1 big image */}
                                <Col lg={6} className="gallery-col p-0">
                                    <Row className="gallery-inner-row g-3">
                                        <Col xs={6} className="gallery-inner-col">
                                            <div className="collage-item small-item">
                                                <div className="gallery-image-wrapper">
                                                    <img src={sportspic5} className="gallery-image" />
                                                    <div className="image-overlay">
                                                        <div className="overlay-content">
                                                            <p></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xs={6} className="gallery-inner-col">
                                            <div className="collage-item small-item">
                                                <div className="gallery-image-wrapper">
                                                    <img
                                                        src={sportspic6}
                                                        alt="Kabaddi Team"
                                                        className="gallery-image"
                                                    />
                                                    <div className="image-overlay">
                                                        <div className="overlay-content"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xs={12} className="gallery-inner-col">
                                            <div className="collage-item small-item">
                                                <div className="gallery-image-wrapper">
                                                    <img src={sportspic7} className="gallery-image" />
                                                    <div className="image-overlay">
                                                        <div className="overlay-content">
                                                            <p></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                            <Row className="gallery-row align-items-stretch mt-lg-4 mx-0">
                                {/* Left side - 4 images in 2x2 grid */}
                                <Col lg={6} className="gallery-col p-0">
                                    <Row className="gallery-inner-row g-3">
                                        <Col xs={6} className="gallery-inner-col">
                                            <div className="collage-item small-item">
                                                <div className="gallery-image-wrapper">
                                                    <img src={sportspic9} className="gallery-image" />
                                                    <div className="image-overlay">
                                                        <div className="overlay-content">
                                                            <p></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xs={6} className="gallery-inner-col">
                                            <div className="collage-item small-item">
                                                <div className="gallery-image-wrapper">
                                                    <img
                                                        src={sportspic10}
                                                        alt="Kabaddi Team"
                                                        className="gallery-image"
                                                    />
                                                    <div className="image-overlay">
                                                        <div className="overlay-content"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xs={12} className="gallery-inner-col">
                                            <div className="collage-item small-item">
                                                <div className="gallery-image-wrapper">
                                                    <img src={sportspic11} className="gallery-image" />
                                                    <div className="image-overlay">
                                                        <div className="overlay-content">
                                                            <p></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>

                                {/* Right side - 1 big image */}
                                <Col lg={6} className="gallery-col">
                                    <div className="collage-item large-item">
                                        <div className="gallery-image-wrapper">
                                            <img src={sportspic12} className="gallery-image" />
                                            <div className="image-overlay">
                                                <div className="overlay-content">
                                                    <h3></h3>
                                                    <p></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                        <div
                            class="tab-pane fade"
                            id="nav-hostel"
                            role="tabpanel"
                            aria-labelledby="nav-hostel-tab"
                            tabindex="0"
                        >
                            <Row className="gallery-row align-items-stretch mt-lg-5 mx-0">
                                {/* Left side - 4 images in 2x2 grid */}
                                <Col lg={6} className="gallery-col p-0">
                                    <Row className="gallery-inner-row g-3">
                                        <Col xs={6} className="gallery-inner-col">
                                            <div className="collage-item small-item">
                                                <div className="gallery-image-wrapper">
                                                    <img src={hostelpic1} className="gallery-image" />
                                                    <div className="image-overlay">
                                                        <div className="overlay-content">
                                                            <p></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xs={6} className="gallery-inner-col">
                                            <div className="collage-item small-item">
                                                <div className="gallery-image-wrapper">
                                                    <img
                                                        src={hostelpic2}
                                                        alt="Kabaddi Team"
                                                        className="gallery-image"
                                                    />
                                                    <div className="image-overlay">
                                                        <div className="overlay-content"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xs={12} className="gallery-inner-col">
                                            <div className="collage-item small-item">
                                                <div className="gallery-image-wrapper">
                                                    <img src={hostelpic3} className="gallery-image" />
                                                    <div className="image-overlay">
                                                        <div className="overlay-content">
                                                            <p></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>

                                {/* Right side - 1 big image */}
                                <Col lg={6} className="gallery-col">
                                    <div className="collage-item large-item">
                                        <div className="gallery-image-wrapper">
                                            <img src={hostelpic4} className="gallery-image" />
                                            <div className="image-overlay">
                                                <div className="overlay-content">
                                                    <h3></h3>
                                                    <p></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row className="gallery-row align-items-stretch mt-lg-4 mx-0">
                                {/* Left side - 4 images in 2x2 grid */}
                                <Col lg={6} className="gallery-col">
                                    <div className="collage-item large-item">
                                        <div className="gallery-image-wrapper">
                                            <img src={hostelpic8} className="gallery-image" />
                                            <div className="image-overlay">
                                                <div className="overlay-content">
                                                    <h3></h3>
                                                    <p></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>

                                {/* Right side - 1 big image */}
                                <Col lg={6} className="gallery-col p-0">
                                    <Row className="gallery-inner-row g-3">
                                        <Col xs={6} className="gallery-inner-col">
                                            <div className="collage-item small-item">
                                                <div className="gallery-image-wrapper">
                                                    <img src={hostelpic5} className="gallery-image" />
                                                    <div className="image-overlay">
                                                        <div className="overlay-content">
                                                            <p></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xs={6} className="gallery-inner-col">
                                            <div className="collage-item small-item">
                                                <div className="gallery-image-wrapper">
                                                    <img
                                                        src={hostelpic6}
                                                        alt="Kabaddi Team"
                                                        className="gallery-image"
                                                    />
                                                    <div className="image-overlay">
                                                        <div className="overlay-content"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xs={12} className="gallery-inner-col">
                                            <div className="collage-item small-item">
                                                <div className="gallery-image-wrapper">
                                                    <img src={hostelpic7} className="gallery-image" />
                                                    <div className="image-overlay">
                                                        <div className="overlay-content">
                                                            <p></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                        <div
                            class="tab-pane fade"
                            id="nav-workshops"
                            role="tabpanel"
                            aria-labelledby="nav-workshops-tab"
                            tabindex="0"
                        >
                            <Row className="gallery-row align-items-stretch mt-lg-5 mx-0">
                                {/* Left side - 4 images in 2x2 grid */}
                                <Col lg={6} className="gallery-col p-0">
                                    <Row className="gallery-inner-row g-3">
                                        <Col xs={6} className="gallery-inner-col">
                                            <div className="collage-item small-item">
                                                <div className="gallery-image-wrapper">
                                                    <img src={workshopspic1} className="gallery-image" />
                                                    <div className="image-overlay">
                                                        <div className="overlay-content">
                                                            <p></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xs={6} className="gallery-inner-col">
                                            <div className="collage-item small-item">
                                                <div className="gallery-image-wrapper">
                                                    <img
                                                        src={workshopspic2}
                                                        alt="Kabaddi Team"
                                                        className="gallery-image"
                                                    />
                                                    <div className="image-overlay">
                                                        <div className="overlay-content"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xs={12} className="gallery-inner-col">
                                            <div className="collage-item small-item">
                                                <div className="gallery-image-wrapper">
                                                    <img src={workshopspic3} className="gallery-image" />
                                                    <div className="image-overlay">
                                                        <div className="overlay-content">
                                                            <p></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>

                                {/* Right side - 1 big image */}
                                <Col lg={6} className="gallery-col">
                                    <div className="collage-item large-item">
                                        <div className="gallery-image-wrapper">
                                            <img src={workshopspic4} className="gallery-image" />
                                            <div className="image-overlay">
                                                <div className="overlay-content">
                                                    <h3></h3>
                                                    <p></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                            <Row className="gallery-row align-items-stretch mt-lg-4 mx-0">
                                {/* Left side - 4 images in 2x2 grid */}
                                <Col lg={6} className="gallery-col">
                                    <div className="collage-item large-item">
                                        <div className="gallery-image-wrapper">
                                            <img src={workshopspic8} className="gallery-image" />
                                            <div className="image-overlay">
                                                <div className="overlay-content">
                                                    <h3></h3>
                                                    <p></p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>

                                {/* Right side - 1 big image */}
                                <Col lg={6} className="gallery-col p-0">
                                    <Row className="gallery-inner-row g-3">
                                        <Col xs={6} className="gallery-inner-col">
                                            <div className="collage-item small-item">
                                                <div className="gallery-image-wrapper">
                                                    <img src={workshopspic5} className="gallery-image" />
                                                    <div className="image-overlay">
                                                        <div className="overlay-content">
                                                            <p></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xs={6} className="gallery-inner-col">
                                            <div className="collage-item small-item">
                                                <div className="gallery-image-wrapper">
                                                    <img
                                                        src={workshopspic6}
                                                        alt="Kabaddi Team"
                                                        className="gallery-image"
                                                    />
                                                    <div className="image-overlay">
                                                        <div className="overlay-content"></div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col xs={12} className="gallery-inner-col">
                                            <div className="collage-item small-item">
                                                <div className="gallery-image-wrapper">
                                                    <img src={workshopspic7} className="gallery-image" />
                                                    <div className="image-overlay">
                                                        <div className="overlay-content">
                                                            <p></p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                    </Row>
                                </Col>
                            </Row>
                        </div>
                    </div>
                </div>
            </section>

            <section className="ptb-50">
                <div className="container-xxl">
                    <div class="text-center mb-5">
                        <h2 class="section-title modern-title text-blue mt-3">Our Campus Facilities</h2>
                        <p class="section-subtitle mx-auto fw-semibold">
                            At ISBM University, we are committed to developing leaders who are not merely skilled professionals but also compassionate people with strong ethical values.
                        </p>
                    </div>
                    <div class="row g-4">
                        <div class="col-md-6 col-lg-4">
                            <div class="card h-100 shadow card-facilities">
                                <div class="card-body text-center p-4">
                                    <div class="card-icon">
                                        <i class="ti ti-building"></i>
                                    </div>
                                    <h4 class="card-title">Modern Infrastructure</h4>
                                    <p class="card-text">The campus is equipped with modern facilities, including lecture halls, seminar rooms, and auditoriums designed for a conducive learning environment.</p>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6 col-lg-4">
                            <div class="card h-100 shadow card-facilities">
                                <div class="card-body text-center p-4">
                                    <div class="card-icon">
                                        <i class="ti ti-book"></i>
                                    </div>
                                    <h4 class="card-title">Well-Stocked Library</h4>
                                    <p class="card-text">A vast collection of books, journals, and digital resources is available for students to support their academic journey.</p>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6 col-lg-4">
                            <div class="card h-100 shadow card-facilities">
                                <div class="card-body text-center p-4">
                                    <div class="card-icon">
                                        <i class="ti ti-flask"></i>
                                    </div>
                                    <h4 class="card-title">Specialized Laboratories</h4>
                                    <p class="card-text">State-of-the-art labs for various fields of study allow students to gain practical, hands-on experience in their disciplines.</p>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6 col-lg-4">
                            <div class="card h-100 shadow card-facilities">
                                <div class="card-body text-center p-4">
                                    <div class="card-icon">
                                        <i class="ti ti-play-basketball"></i>
                                    </div>
                                    <h4 class="card-title">Sports Facilities</h4>
                                    <p class="card-text">Fields for cricket, football, basketball, and indoor games promote physical fitness and a healthy lifestyle among students.</p>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6 col-lg-4">
                            <div class="card h-100 shadow card-facilities">
                                <div class="card-body text-center p-4">
                                    <div class="card-icon">
                                        <i class="ti ti-home"></i>
                                    </div>
                                    <h4 class="card-title">Hostel Accommodation</h4>
                                    <p class="card-text">Comfortable hostel facilities provide a supportive community living environment for students.</p>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6 col-lg-4">
                            <div class="card h-100 shadow card-facilities">
                                <div class="card-body text-center p-4">
                                    <div class="card-icon">
                                        <i class="ti ti-salad"></i>
                                    </div>
                                    <h4 class="card-title">Cafeteria</h4>
                                    <p class="card-text">A variety of nutritious meals and snacks are served to ensure students have access to healthy food options on campus.</p>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6 col-lg-4">
                            <div class="card h-100 shadow card-facilities">
                                <div class="card-body text-center p-4">
                                    <div class="card-icon">
                                        <i class="ti ti-icons"></i>
                                    </div>
                                    <h4 class="card-title">Extracurricular Activities</h4>
                                    <p class="card-text">Clubs, cultural events, and seminars enhance students' overall development beyond academics.</p>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6 col-lg-4">
                            <div class="card h-100 shadow card-facilities">
                                <div class="card-body text-center p-4">
                                    <div class="card-icon">
                                        <i class="ti ti-briefcase"></i>
                                    </div>
                                    <h4 class="card-title">Placement Cell</h4>
                                    <p class="card-text">A dedicated team assists students with career counseling, internships, and job placements.</p>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6 col-lg-4">
                            <div class="card h-100 shadow card-facilities">
                                <div class="card-body text-center p-4">
                                    <div class="card-icon">
                                        <i class="ti ti-leaf"></i>
                                    </div>
                                    <h4 class="card-title">Green Campus</h4>
                                    <p class="card-text">Landscaped gardens and eco-friendly practices maintain a sustainable environment on campus.</p>
                                </div>
                            </div>
                        </div>

                        <div class="col-md-6 col-lg-4 mx-auto">
                            <div class="card h-100 shadow card-facilities">
                                <div class="card-body text-center p-4">
                                    <div class="card-icon">
                                        <i class="ti ti-wheelchair"></i>
                                    </div>
                                    <h4 class="card-title">Accessibility</h4>
                                    <p class="card-text">The campus is designed to be fully accessible to all students, including those with disabilities.</p>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>
            </section>
            <Footer />
        </>
    );
};

export default CampusInfrastructure;